<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

$(document).ready(function() {
  
    //Collection description more information toggle
  var productDescription = $('.articleLookbook-des'),
      productReadMore = $('.collection-read-more'),
      currentHeight = productDescription.height(),
      autoHeight = productDescription.css('height', 'auto').height(),
      showMoreText = 'Read More',
      showLessText = 'Read Less';

  productDescription.css('height', currentHeight);

  productReadMore.click(function(){
      if ($(this).hasClass('active')) {
          $(this).removeClass('active');
          productDescription.removeClass('active');
          productDescription.height(currentHeight).animate({height: currentHeight}, 0);
          productReadMore.find('.text_more').html(showMoreText);
      } else {
          $(this).addClass('active');
          productDescription.addClass('active');
          productDescription.height(currentHeight).animate({height: autoHeight}, 0);
          productReadMore.find('.text_more').html(showLessText);
      }
  });

if (window.innerWidth > 1025) {

      $('#tab-description > div.toggle-title > a > span.text').click();
}

  
});
